import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Avatar, Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_DOCUMENT_CATEGORY,
  setDocumentCategory,
  DELETING_DOCUMENT_CATEGORY,
} from "../../store/document-store/reducer";

const EmploymentAwards = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { documentCategory } = useSelector(
    ({ documents }) => documents.documentReducer
  );
  const [isLoading, setIsLoading] = useState(true);
  const { csvExportData } = useSelector(({ user }) => user.userReducer);
  const [dataList, setDataList] = useState([]);
  const [csv, setCsv] = useState({
    headers: [
      {
        label: "Code",
        key: "code",
      },
      {
        label: "Description",
        key: "description",
      },
      {
        label: "Status",
        key: "status",
      },
    ],
    data: [],
    fileName: "allDocumentCategory.csv",
  });

  const handleColumnCsv = (array) => {
    let csvData = [];
    array?.forEach((e) => {
      csvData.push({
        code: e.code,
        description: e.description,
        status: e.status,
      });
    });
    return csvData;
  };

  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.status - a.status,
    },
  ];

  const FETCH_DATA = () => {
    FETCH_DOCUMENT_CATEGORY(organisationId)
      .then((data) => dispatch(setDocumentCategory(data)))
      .finally(() => setIsLoading(false));
    setIsLoading(false);
  };

  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    if (documentCategory) {
      const columns = handleColumnCsv(documentCategory);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [documentCategory]);

  useEffect(() => {
    if (csvExportData.length > 0) {
      const columns = handleColumnCsv(csvExportData);
      setCsv({
        ...csv,
        data: columns,
      });
    }
  }, [csvExportData]);

  useEffect(() => {
    const newDoc = [];
    documentCategory?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.description}`,
        description: `${ele?.code}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [documentCategory]);

  return (
    <div className="team_member">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Document Categories" }]}
            dataSource={documentCategory && documentCategory}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_DOCUMENT_CATEGORY}
            table="documents/categories"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={csv.headers || null}
            csvData={csv.data || null}
            csvFileName={csv.fileName || null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Document Categories" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETING_DOCUMENT_CATEGORY}
            table="documents/categories"
          />
        </div>
      </div>
    </div>
  );
};

export default EmploymentAwards;
